export const defaultModule = {
  crm: { state: true, colorKey: 'data' },
  audiences: { state: true, colorKey: 'insight' },
  alice: { state: true, colorKey: 'content' },
  activation: { state: true, colorKey: 'activation' },
  funnel: { state: true, colorKey: 'funnel' },
  ermesLive: { state: true, colorKey: 'live' },
  pilotage: { state: false }
};

export default defaultModule;
